export default __webpack_public_path__ + "static/media/logo.1d74712e.svg";